/*
 * @Description: 
 * @Date: 2020-07-20 10:09:23
 * @LastEditTime: 2021-01-07 16:24:17
 */ 
import request from '@/utils/request.js'

export function appCreate(data) {
    return request({
        url: '/api/gen/app/',
        method: 'post',
        data
    })
}

export function appList(params) {
    return request({
        url: `api/gen/app/`,
        method: 'get',
        params
    })
}

export function appDetail(params) {
    return request({
        url: `/api/gen/app/${params.id}`,
        method: 'get'
    })
}

export function appUpdate(data) {
    let id = data.get("id")
    return request({
        url: `/api/gen/app/${id}/`,
        method: 'patch',
        data
    })
}

export function appDelete(data) {
    return request({
        url: `/api/gen/app/${data.id}`,
        method: 'delete'
    })
}

export function countryList(params) {
    return request({
        url: `api/conf/country/`,
        method: 'get',
        params
    })
}

export function mediaList(params) {
    return request({
        url: `api/conf/mediachannel/`,
        method: 'get',
        params
    })
}

export function eventList(params) {
    return request({
        url: `api/gen/app/${params.id}`,
        method: 'get'
    })
}

export function addEvent(data) {
    let _data = Object.assign({}, data)
    delete _data.id
    return request({
        url: `api/gen/app/${data.id}/`,
        method: 'patch',
        data: _data
    })
}
 
export function incomeList(data){
    return request({
        url: 'api/dashboard/p_e/',
        method: 'post',
        data
    })
}

export function incomeAllList(data){
    return request({
        url: 'api/dashboard/p_t/',
        method: 'post',
        data
    })
}